import React from 'react'
import { func, bool } from 'prop-types'

import {
  TagComponent, Button, Close, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function PromoteModelHeader({ onModalClose, isReadOnly }) {
  return (
    <div className="promote-modal__header">
      <div className="promote-modal__header-left">
        <h1 className="promote-modal__title">{isReadOnly ? 'Promotion Campaign' : 'New Promotion Campaign'}</h1>
        <TagComponent
          className="promote-modal__beta-tag"
          type="ghost"
        >
          BETA
        </TagComponent>
      </div>
      <Button
        size="small"
        type="ghost"
        variant="only-icon"
        onClick={onModalClose}
        icon={<Icon svgComponent={Close} />}
      />
    </div>
  )
}

PromoteModelHeader.propTypes = {
  onModalClose: func.isRequired,
  isReadOnly: bool.isRequired,
}

export default PromoteModelHeader
